import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";
import moment from "moment";

const getDefaultSelectedNotification = () => {
  return {
    ticketProcessTypes: [],
    trainTypes: [],
    salesChannelIds: [],
    cabinClassIds: [],
    passengerTypeIds: [],
    startDate: null,
    endDate: null,
    trainParameters: [],
    schedule: { startDate: null, endDate: null },
    content: "",
  };
};

export default {
  state: () => ({
    selectedNotification: getDefaultSelectedNotification(),
  }),

  mutations: {
    setSelectedNotification(state, notification) {
      Vue.set(state, "selectedNotification", notification);
    },
    setDefaultSelectedNotification(state) {
      Vue.set(state, "selectedNotification", getDefaultSelectedNotification());
    },
  },
  actions: {
    //TODO: load, update, create
    createNotification: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/notification-management/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadNotifications: (context, request) => {
      //TODO: Loader start
      return axios
        .get(context.getters.getMcServiceUrl + "/notification-management/entity", {})
        .then((response) => {
          //TODO: Loader end
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadNotification: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/entity/" + request.id).then((response) => {
        response.data.startDate = moment(response.data.startDate).add(3, "hours").format("DD.MM.YYYY");
        response.data.endDate = moment(response.data.endDate).add(3, "hours").format("DD.MM.YYYY");
        if (response.data.schedule) {
          response.data.schedule.startDate = moment(response.data.schedule.startDate).format("DD.MM.YYYY");
          response.data.schedule.endDate = moment(response.data.schedule.endDate).format("DD.MM.YYYY");
        } else {
          response.data.schedule = { startDate: null, endDate: null };
        }

        context.commit("setSelectedNotification", response.data);
        return response.data;
      });
    },
    loadSelectedNotificationHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteNotification: (context, notification) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/notification-management/entity/" + notification.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          notification.intents = intents;
          notification.intentId = response.data.id;
          return notification;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishNotification: (context, notification) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/publish/" + notification.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectNotification: (context, notification) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/reject/" + notification.intentId).then((response) => {
        if (notification.intents[0].type === "DELETE_ANNOUNCEMENT") {
          notification.intents = null;
          notification.intentId = 0;
        } else if (notification.intents[0].type === "CREATE_ANNOUNCEMENT") {
          notification.intents[0].status = "DRAFT";
        } else if (notification.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          notification.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    sendToApprovalNotification: (context, notification) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/sendToApproval/" + notification.intentId).then((response) => {
        if (notification.intents[0].type === "CREATE_ANNOUNCEMENT") {
          notification.intents[0].status = "WAITING_APPROVAL";
        } else if (notification.intents[0].type === "UPDATE_ANNOUNCEMENT") {
          notification.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallNotification: (context, notification) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/recall/" + notification.intentId).then((response) => {
        helper.recallOrRejectEntity(notification, "notification");
        return response.data;
      });
    },

    cancelNotification: (context, notification) => {
      return axios.get(context.getters.getMcServiceUrl + "/notification-management/cancel/" + notification.intentId).then((response) => {
        return response.data;
      });
    },
    fetchPassengersInformationInTrain: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/notification-management/get-train-passengers", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendTrainPassengersSms: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/notification-management/send-train-passengers-sms", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    sendTrainPassengersEmail: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/notification-management/send-train-passengers-mail", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedNotification: (state) => {
      return state.selectedNotification;
    },
  },
};
